module.exports = __webpack_public_path__ + "static/media/waterSport1.fa5cab03.jpg";